import client from './client';

export interface LlmModelOption {
  value: string;
  label: string;
  description: string | null;
  /** Still runs for an existing pick, but is no longer offered for a new one. */
  deprecated: boolean;
}

export async function listLlmModels(): Promise<LlmModelOption[]> {
  const response = await client.get('/api/v1/conversations/llm-models', {
    params: { includeDeprecated: true },
  });
  return response.data;
}
